import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { KeyDrop, RecordMerge } from "@pdfking/tfunc"
import { Icon } from "@pdfking/workflow/components/Icon"
import can_hover from "../../../features/can_hover"
import cx from "../../../utils/cx"

export const Filters = CreateRenderFunction({
  data: {
    hover: {} as Record<string, ReturnType<typeof setTimeout>>,
  },
  methods: {
    hover_cancel(id: string) {
      if (can_hover() && this.hover[id]) {
        clearTimeout(this.hover[id])
        this.hover = KeyDrop(this.hover, [id])
      }
    },

    hover_start(id: string) {
      if (can_hover()) {
        this.hover_cancel(id)

        this.hover = RecordMerge(this.hover, {
          [id]: setTimeout(() => {
            this.hover_cancel(id)
            this.action(id)
          }, 200),
        })
      }
    },
  },
  props: {
    action: null as ((selected: string) => void) | null,
    badge: false,
    class: "",
    filters: [] as { id: string; title: string; count?: number }[],
    selected: "" as string,
  },
  render() {
    return (
      <div class={`list-group list-group-flush ${this.class}`}>
        {(this.filters as any[]).map((filter: any) => (
          <a
            class={cx(
              "list-group-item list-group-item-action d-flex align-items-center",
              { active: filter.id === this.selected }
            )}
            href="#"
            key={filter.id}
            onClick={(e: Event) => {
              e.stopPropagation()
              e.preventDefault()
              this.action(filter.id)
            }}
            onBlur={() => this.hover_cancel(filter.id)}
            onFocus={() => this.hover_start(filter.id)}
            onMouseOut={() => this.hover_cancel(filter.id)}
            onMouseOver={() => this.hover_start(filter.id)}
          >
            {filter.icon && <Icon class="me-1" name={filter.icon} />}
            <span dangerouslySetInnerHTML={{ __html: filter.title }} />
            {filter.badge ? (
              <span
                class="position-absolute end-0 me-2 bg-light text-primary badge rounded-pill"
                dangerouslySetInnerHTML={{ __html: filter.badge }}
              />
            ) : (
              <Icon class="position-absolute end-0 me-2" name="CHEVRON_RIGHT" />
            )}
          </a>
        ))}
      </div>
    )
  },
})
